import React from "react"
import { Link } from "react-router"

import { Button } from "@/components/ui/button"

export default function NotFound() {
  return (
    <div className="bg-white antialiased dark:bg-zinc-900">
      <div className="flex h-screen w-full items-center justify-center">
        <div className="text-center">
          <h2 className="mb-5 font-space-mono">Nothing to see here!</h2>
          <Link to="/">
            <Button>Go to the home page</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
